import { HistoryCashbackPayload } from '@/backend/api'

export const CASHBACK_TRANSACTIONS_SORTING: HistoryCashbackPayload['sortParams'] = {
  direction: 'desc',
  sortBy: 'time',
}
export const CASHBACK_TRANSACTIONS_SIZE = 20
